import { FC } from 'react';

import { styled, Typography, useTheme } from '@mui/material';

interface Props {
  isCentered?: boolean;
  children: string | string[];
}

export const Title: FC<Props> = ({ children, isCentered = false }) => {
  const { palette } = useTheme();

  return (
    <StyledTitle
      variant="h1"
      mb={6}
      color={palette.text.primary}
      align={isCentered ? 'center' : 'left'}
    >
      {children}
    </StyledTitle>
  );
};

const StyledTitle = styled(Typography)`
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  width: 100%;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  flex-shrink: 0;
`;
